import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import FloorColumns from "../../../../models/ColumnDefinitions/FloorColumn";
import FloorSearch from "../../../../models/search/FloorSearch";
import { hideColumns } from "../../../../models/utilities/columnHelper";
import { getFloors } from "../../../../services/floorService";
import TableTab from "../../../tabs/table-tab";

interface FloorEntityProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const FloorEntity: FC<FloorEntityProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const [selectIds, setSelectIds] = useState<string[]>([]);
    const {setFieldValue} = useFormikContext<any>();

    const onSelectedIds = (selectedIds: string[]) => {
        setFieldValue('filterIds', selectedIds);
        setSelectIds([...selectedIds]);
    }  

    return <div className="pt-3 pr-3 pl-3 h-full">
        <TableContextProvider
            dataMethod={getFloors}
            useTable
            usePagination
            useFilter
            useSearch
            useSort
            tableDescriptor={hideColumns(FloorColumns, ["inputs"])}
            searchDescriptor={FloorSearch}
            maxPageSize={DEF_PG_SIZE_WIZARD}
            canExportReport={false}>
            <TableTab
                title={translate.byKey(TranslationKeys.floors)}
                selectRows={true}
                selectedIds={selectIds}
                setSelectedIds={onSelectedIds}
                tableId={'floorEntity'}
                cyName="floorEntity">
            </TableTab>
        </TableContextProvider>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="button"
                    onClick={e => onNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default FloorEntity;